<script>
import CMSSinglePage from "@/views/components/cms/CMSSinglePage.vue";

export default {
  name: "WohngeldKZuschlag",
  components: {CMSSinglePage},
}
</script>

<template>
 <CMSSinglePage list-element="WohngeldKZuschlagList"></CMSSinglePage>
</template>

<style scoped>

</style>
